import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../context/AuthContext';
import './SubscriptionExpired.scss';

export default function SubscriptionExpired() {
    const { isLoggedIn } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className='subscriptionExpired'>
            <Helmet>
                <title>Subskrypcja wygasła | Nekrodruk.pl</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className='subscriptionExpired_wrapper'>
                <h1>Subskrypcja wygasła</h1>
                <p>Twoja subskrypcja wygasła. Aby ją przedłużyć, wybierz pakiet albo wpisz kod promocyjny – możesz też napisać do nas.</p>
                {isLoggedIn && (
                    <Button component={NavLink} to='/subscription' variant='contained' className='subscriptionExpired_cta'>
                        Przejdź do subskrypcji
                    </Button>
                )}
                <p className='subscriptionExpired_contact'>Kontakt: <a href='mailto:nekrodruk@gmail.com'>nekrodruk@gmail.com</a></p>
                <NavLink to='/' className='subscriptionExpired_home'>Wróć na stronę główną</NavLink>
            </div>
        </section>
    );
}
